// Privacy.jsx
export default function Privacy() {
    return (
        <div className="space-y-4">
            <h1 className="text-4xl font-semibold">Privacy Policy</h1>
            <p className="mb-2">
                This website does not collect, store, or share any personal data of users.
            </p>
            <p className="mb-2">
                No cookies or tracking scripts are used. All operations happen locally in your browser.
            </p>
            <p className="mb-2">
                Third-party content or API calls may be subject to their own privacy policies.
            </p>
        </div>
    );
}
